"use client";
import { useState as a, useEffect as u, useMemo as d } from "react";
const f = {
  xs: 480,
  sm: 640,
  md: 768,
  lg: 1024,
  xl: 1170
}, h = (n) => {
  const [o, s] = a(!1), [t, i] = a(!1);
  u(() => {
    i(!0);
  }, []);
  const e = d(() => typeof window > "u" ? null : window.matchMedia(`(max-width: ${f[n]}px)`), [n]);
  return u(() => {
    if (!t || !e) return;
    const r = (c) => {
      s(c.matches);
    };
    return s(e.matches), e.addEventListener("change", r), () => {
      e.removeEventListener("change", r);
    };
  }, [e, t]), t ? o : !1;
};
export {
  h as default,
  h as useMediaQuery
};
